// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-grey[data-v-3d6232d8] {\n    color: #9e9e9e;\n}\n", ""]);
// Exports
module.exports = exports;
